import { Outlet } from "react-router-dom";

export const AppShellLayout = () => {
  return (
    <div className="AppShellLayout relative mx-auto flex min-h-dvh w-full flex-col desk:overflow-x-clip">
      <Outlet />
    </div>
  );
};
